import React from 'react';

export default function Footer() {
    return (
        <footer className='footer-container'>
            <p>Created by <a href="https://github.com/norfkorean/react-memorycard-project" target="_blank">Ji Park</a></p>
        </footer>
    )
}
